import SectionPricing from './SectionPricing';
export default SectionPricing;
